export const CLIENT_ID = 'wps' as const;
export const DATABASE_LABEL = 'main' as const;
export const RESPONSE_YES = 'yes' as const;
export const RESPONSE_NO = 'no' as const;

export const MUI_LICENSE_KEY =
  'd60cb0cb4121df7ee0c70c00c22b5714Tz04OTQwNixFPTE3NDYwMzUyMjIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=';

export const ONE_MINUTE = 60000;
export const THIRTY_SECONDS = ONE_MINUTE / 2;
export const ONE_HOUR = ONE_MINUTE * 60;

export const USER_GUIDE_PDF = 'user-guide.pdf';

export const DOWN_TIME_HOURS = [
  {
    startHour: '10:00 am', // 10am central
    endHour: '10:30 am',
  },
  {
    startHour: '12:00 pm', // 12pm central
    endHour: '1:00 pm',
  },
];
